var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5.5a.5.5 0 0 0-1 0V2h-.167A2.333 2.333 0 0 0 0 4.333V9.5A2.5 2.5 0 0 0 2.5 12h7A2.5 2.5 0 0 0 12 9.5V4.333A2.333 2.333 0 0 0 9.667 2H9.5V.5a.5.5 0 0 0-1 0V2h-5zM1 4.333C1 3.597 1.597 3 2.333 3h7.334C10.403 3 11 3.597 11 4.333V9.5A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5zm5.362-.178a.5.5 0 0 0-.724 0L4.146 5.646a.5.5 0 1 0 .708.708l.646-.647V9H5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5V5.707l.646.647a.5.5 0 1 0 .708-.708z",
    clipRule: "evenodd"
  })));
});
const SvgApCreditNotessmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApCreditNotessmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjUgMC41QzMuNSAwLjIyMzg1OCAzLjI3NjE0IDAgMyAwQzIuNzIzODYgMCAyLjUgMC4yMjM4NTggMi41IDAuNVYySDIuMzMzMzNDMS4wNDQ2NyAyIDAgMy4wNDQ2NyAwIDQuMzMzMzNWOS41QzAgMTAuODgwNyAxLjExOTI5IDEyIDIuNSAxMkg5LjVDMTAuODgwNyAxMiAxMiAxMC44ODA3IDEyIDkuNVY0LjMzMzMzQzEyIDMuMDQ0NjcgMTAuOTU1MyAyIDkuNjY2NjcgMkg5LjVWMC41QzkuNSAwLjIyMzg1OCA5LjI3NjE0IDAgOSAwQzguNzIzODYgMCA4LjUgMC4yMjM4NTggOC41IDAuNVYySDMuNVYwLjVaTTEgNC4zMzMzM0MxIDMuNTk2OTUgMS41OTY5NSAzIDIuMzMzMzMgM0g5LjY2NjY3QzEwLjQwMyAzIDExIDMuNTk2OTUgMTEgNC4zMzMzM1Y5LjVDMTEgMTAuMzI4NCAxMC4zMjg0IDExIDkuNSAxMUgyLjVDMS42NzE1NyAxMSAxIDEwLjMyODQgMSA5LjVWNC4zMzMzM1pNNi4zNjE4IDQuMTU0NjlDNi4yNzA3NCA0LjA1OTI2IDYuMTQyMzEgMy45OTk4IDYgMy45OTk4QzUuODU3NjkgMy45OTk4IDUuNzI5MjcgNC4wNTkyNiA1LjYzODIyIDQuMTU0NjhMNC4xNDY0NSA1LjY0NjQ1QzMuOTUxMTggNS44NDE3MSAzLjk1MTE4IDYuMTU4MjkgNC4xNDY0NSA2LjM1MzU1QzQuMzQxNzEgNi41NDg4MiA0LjY1ODI5IDYuNTQ4ODIgNC44NTM1NSA2LjM1MzU1TDUuNSA1LjcwNzExVjlINUM0LjcyMzg2IDkgNC41IDkuMjIzODYgNC41IDkuNUM0LjUgOS43NzYxNCA0LjcyMzg2IDEwIDUgMTBIN0M3LjI3NjE0IDEwIDcuNSA5Ljc3NjE0IDcuNSA5LjVDNy41IDkuMjIzODYgNy4yNzYxNCA5IDcgOUg2LjVWNS43MDcxMUw3LjE0NjQ1IDYuMzUzNTVDNy4zNDE3MSA2LjU0ODgyIDcuNjU4MjkgNi41NDg4MiA3Ljg1MzU1IDYuMzUzNTVDOC4wNDg4MiA2LjE1ODI5IDguMDQ4ODIgNS44NDE3MSA3Ljg1MzU1IDUuNjQ2NDVMNi4zNjE4IDQuMTU0NjlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";